/**
 * Type imports
 * @ts-check
 @typedef {import("../types/badge").BadgeColour} BadgeColour
 */

/**
 * @param {BadgeColour} color
 * @returns string
 */
const handleBadgeColour = (color) => {
  switch (color) {
    case 'VIOLET': {
      return 'bg-secondary-violet text-black'
    }
    case 'BLUE': {
      return 'bg-primary-blue text-white'
    }
    case 'GREEN': {
      return 'bg-secondary-green text-white'
    }
    case 'RED': {
      return 'bg-red text-white'
    }
    case 'YELLOW': {
      return 'bg-secondary-yellow text-black'
    }
    default: {
      return ''
    }
  }
}

const handleBadgeWidth = (size) => {
  if (size === 'full') return 'w-full'
  return 'w-fit'
}

/**
 * @param {{
 *  title: string
 *  color: BadgeColour,
 *  size: 'fit' | 'full'
 * }} props
 * @returns JSXInternal.Element
 */
export const AccountBadge = (props) => {
  const badgeColour = handleBadgeColour(props.color)
  const size = handleBadgeWidth(props.size)
  return (
    <div className={`${size} -rotate-2 ${badgeColour} p-2 ${props.className || ''} flex items-center`}>
      <div className={'paragraph-xs flex flex-col items-center justify-between font-bold'}>{props.title}</div>
    </div>
  )
}
